import React, { useState } from "react";
import { Box, Heading, Button, Grid, Text, Layer } from "grommet";
import { Info, MailOption } from "grommet-icons";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderNavigation } from "../../components/Headers/PursuitHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import DashboardTourModal from "../../components/PursuitAccess/DashboardTourModal";

const PursuitAccessDashboard = () => {
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const [showEmailModal, setShowEmailModal] = useState(false);

    const cardItems = [
        {
            title: "View User Self Assessments",
            description:
                "View and manage assessments created by users. You can also view the assessment recommendations.",
            buttonText: "View User Self Assessments",
            action: () => navigate(`/pursuit/self-assessments`),
        },
        {
            title: "View Manager Created Assessments",
            description:
                "View and manage assessments created by managers. You can also view the assessment recommendations.",
            buttonText: "View Manager Created Assessments",
            action: () => navigate(`/pursuit/manager-assessments`),
        },
        {
            title: "Dedicated Learning Requests",
            description:
                "Review all submitted dedicated/custom learning requests from users.",
            buttonText: "View Requests",
            action: () => navigate(`/pursuit/dedicated-requests`),
        },
        {
            title: "Help",
            description: (
                <>
                    <Text
                        color="brand"
                        style={{ cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => setShowEmailModal(true)}
                    >
                        Email Support
                    </Text>
                </>
            ),
            // buttonText: "Experiencing any issues?",
            action: () => navigate(`/pursuit/contact`),
        },
    ];
    return (
        <Box fill="vertical" overflow="auto" background="light-1">
            <HeaderNavigation />
            <Box pad={{ horizontal: "large", vertical: "medium" }} flex="grow">
                <Box direction="row" justify="between" align="center" width="100%">
                    {/* Left Box: Info Icon + Welcome Message */}
                    <Box
                        direction="row"
                        align="center"
                        gap="small"
                        pad="small"
                        background="white"
                        elevation="small"
                        round="small"
                        border={{ color: "brand", size: "xsmall" }}
                        width="auto" // Ensures it only covers the content
                        alignSelf="start" // Aligns it to the start
                    >
                        <Info size="medium" color="brand" />
                        <Heading
                            level="3"
                            margin="none"
                            color="brand"
                            textAlign="start"
                            responsive={false}
                            truncate={false}
                        >
                            Welcome to the Pursuit Access Dashboard.
                        </Heading>
                    </Box>

                    {/* Right Box: Quick Start Guide Link */}
                    <Box
                        pad="small"
                        background="white"
                        elevation="small"
                        round="small"
                        border={{ color: "brand", size: "xsmall" }}
                        width="auto" // Ensures it only covers the content
                        alignSelf="end" // Aligns it to the end
                    >
                        <Text
                            color="brand"
                            as="a"
                            onClick={(e) => {
                                e.stopPropagation(); // Prevents the click from triggering the Box click event
                                setShowModal(true);
                            }}
                            style={{ cursor: "pointer", textDecoration: "underline" }}
                        >
                            Quick Start Guide
                        </Text>
                    </Box>
                </Box>

                {/* Quick Actions Heading */}
                <Box align="start" margin={{ top: "small", bottom: "small" }}>
                    <Heading level="2">Actions</Heading>
                </Box>
                <Grid
                    columns={{ count: 3, size: "medium" }}
                    gap="medium"
                    justify="start"
                    responsive
                >
                    {cardItems.map((item, index) => (
                        <Box
                            key={index}
                            elevation="small"
                            round="small"
                            pad="medium"
                            background="white"
                            border={{ color: "brand", size: "xsmall" }}
                            width="100%" // Ensures the box takes full width of the grid column
                            fill="vertical" // Allows the box to stretch vertically
                            direction="column"
                            justify="between" // Distributes space between children
                        >
                            <Box>
                                <Heading
                                    level="3"
                                    margin={{ bottom: "small" }}
                                    textAlign="start"
                                >
                                    {item.title}
                                </Heading>
                                <Text textAlign="start">{item.description}</Text>
                            </Box>
                            <Box align="start">
                                {item.buttonText ? (
                                    <Button
                                        label={item.buttonText}
                                        primary
                                        onClick={item.action}
                                        margin={{ top: "medium" }}
                                    />
                                ) : null}
                            </Box>
                        </Box>
                    ))}
                </Grid>

            </Box>
            <DashboardTourModal showModal={showModal} setShowModal={setShowModal} />
            <StickyFooter />


            {/* Email Support Modal */}
            {showEmailModal && (
                <Layer
                    onEsc={() => setShowEmailModal(false)}
                    onClickOutside={() => setShowEmailModal(false)}
                >
                    <Box
                        width="large"
                        pad="medium"
                        background="light-2"
                        round="small"
                        elevation="small"
                    >
                        <Heading level={2} margin="none" textAlign="center">
                            Contact Us
                        </Heading>
                        <Text textAlign="center" size="large" margin={{ top: "small" }}>
                            Need help with <strong>HPE Digital Skill Advisor</strong>? Get in touch with
                            us for support.
                        </Text>
                        <Box align="center" margin={{ top: "medium" }}>
                            <Button
                                label="Email Support"
                                icon={<MailOption />}
                                href="mailto: hpeskill.advisor@hpe.com?subject=Support%20needed%20for%20HPE%20Digital%20Skill%20Advisor&body=Hi%2C%0A%0APlease%20provide%20details%20of%20the%20issue%20you%20are%20facing%20with%20HPE%20Digital%20Skill%20Advisor%20in%20this%20email.%20We%20will%20review%20your%20request%2C%20and%20get%20back%20to%20you%20within%2048%20hours.%0A%0AIf%20you%20have%20any%20screenshots%20or%20media%20content%20to%20highlight%20your%20issue%2C%20please%20attach%20it%20to%20this%20email.%0A%0ABest%20Wishes%2C%0AHPE%20Digital%20Skill%20Advisor"
                                primary
                            />
                        </Box>
                        <Box align="center" margin={{ top: "medium" }}>
                            <Button label="Close" onClick={() => setShowEmailModal(false)} />
                        </Box>
                    </Box>
                </Layer>
            )}
        </Box>
    );
};

export default PursuitAccessDashboard;
